import React from 'react';
import styled from 'styled-components';

import TableDataCell from './TableDataCell';
import Tooltip from '../../../misc/Tooltip';

import FieldModes from '../../../../constants/FieldModes';
import { gray3 } from '../../../../constants/Colors';

const StyledHiddenCellContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

/**
 * Placeholder rendered in place of a table/collection cell that is hidden.
 *
 * - Always shows a grey background so the cell keeps its column slot (grid alignment).
 * - Builder (fieldMode !== pdf): also shows the "i" tooltip icon that explains the cell is
 *   hidden. Exporter (fieldMode === pdf): grey background only, no icon.
 */
const HiddenCellPlaceholder = ({ cellKey, width, fieldMode, borderColor, borderWidth, fieldId }) => {

  const showIcon = fieldMode !== FieldModes.pdf;

  return (
    <TableDataCell
      key={cellKey}
      disableHover
      disabled
      width={width}
      backgroundColor={gray3}
      borderColor={borderColor}
      borderWidth={borderWidth}
      padding={0}
    >
      <StyledHiddenCellContent>
        <Tooltip
          tipVisible={showIcon}
          fieldId={`${fieldId || ''}${cellKey}`}
          description="This cell is hidden"
        />
      </StyledHiddenCellContent>
    </TableDataCell>
  );

};

export default React.memo(HiddenCellPlaceholder);
